import React from 'react';
import PropTypes from 'prop-types';
import style from '../../../styles/styles';
import styles from './UserSetting.css';
import { Paper, List, Subheader, Toggle, TextField } from 'material-ui';
import Loading from '../../common/Loading/Loading';
import withTranslation from '../../../hoc/withTranslation';

class UserSetting extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        editConfiguration: PropTypes.func,
    };

    static defaultProps = {
        app: null,
        loading: false,
    };

    handleToggledDeleteInactiveAccounts = (event, isInputChecked) => {
        this.props.editConfiguration('delete_inactive_accounts', isInputChecked);
    };

    handleDeadlineForDeletingInactiveAccountsInMonth = (event) => {
        if (!isNaN(Number(event.target.value))) {
            this.props.editConfiguration('deadline_for_deleting_inactive_accounts_in_month', Number(event.target.value));
        }
    };

    render() {
        const { loading, app } = this.props;
        let content;
        if (loading) {
            content = <Loading paper={false} />;
        } else {
            content =
                <div>
                    <Toggle
                        style={styles.toggle}
                        label={this.props.t('settings_page.delete_inactive_accounts')}
                        toggled={app.configurations.delete_inactive_accounts}
                        labelPosition="right"
                        onToggle={this.handleToggledDeleteInactiveAccounts}
                    />
                    <TextField
                        floatingLabelText={`${this.props.t('settings_page.deadline_for_deleting_inactive_accounts_in_month')} (min: 6)`}
                        defaultValue={app.configurations.deadline_for_deleting_inactive_accounts_in_month}
                        fullWidth={true}
                        onBlur={this.handleDeadlineForDeletingInactiveAccountsInMonth}
                        type="number"
                    />
                </div>;
        }

        return <Paper>
            <List>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('module.user.name')}
                </Subheader>

                <div style={style.paper}>
                    {content}
                </div>
            </List>
        </Paper>;
    }
}

export default withTranslation(UserSetting);



// WEBPACK FOOTER //
// src/components/common/UserSetting/UserSetting.js